import React from "react";

import {
  Dialog,
  DialogContent,
  DialogClose,
  IconButton,
  Button,
  DialogHeading,
} from "components/LibraryComponents/Components";
import { Icon } from "@trussworks/react-uswds";

// styles
import styles from "./OverviewSection.module.scss";

type ReplaceCapabilitiesStatmentDialogProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleClick: () => void;
};

export default function ReplaceCapabilitiesStatmentDialog(
  props: ReplaceCapabilitiesStatmentDialogProps
) {
  return (
    <Dialog
      open={props.open}
      onOpenChange={props.setOpen}
      dismissOutsideClick={false}
    >
      <DialogContent
        className={styles["replace-dialog-root"]}
        hasBackdrop
        lockScroll
      >
        <div className={styles["replace-dialog-body"]}>
          <div className={styles["header"]}>
            <DialogHeading className={styles["heading"]}>
              Replace capabilities statement
            </DialogHeading>

            <IconButton
              type="button"
              Icon={<Icon.Close />}
              size="sm"
              onClick={() => props.setOpen(false)}
              tabIndex={-1}
              aria-label="Close dialog"
              className={styles["close-icon"]}
            />
          </div>

          <div className={styles["replace-content"]}>
            <p className={styles["desc"]}>
              Uploading a new file will overwrite the current capabilities
              statement file or url. This cannot be undone.
              <br /> <br /> If you have uploaded a capabilities statement file
              and want to retain a copy of it for your records, download it
              before replacing it.
            </p>
          </div>
        </div>

        <div className={styles["replace-dialog-footer"]}>
          <Button
            type="button"
            className={styles["btn-close"]}
            onClick={() => props.setOpen(false)}
          >
            Cancel upload
          </Button>

          <Button
            type="button"
            className={styles["btn-submit"]}
            onClick={props.handleClick}
          >
            Upload file
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
